import React from 'react';

import { Section } from '../../data/beans';
import useSeating from '../../hooks/useSeating';
import { getContentClassName } from '../../utils/misc';
import formatSeatCount from '../../utils/seating';

import './stylesheet.scss';

export default function SeatInfo({
  section,
  term,
  color,
}: {
  section: Section;
  term: string;
  color: string | undefined;
}): React.ReactElement {
  const seating = useSeating(section, term);
  const textClass = getContentClassName(color);
  return (
    <div className="SeatInfo">
      <div className="seating-container">
        <div className="seating">
          {(
            [
              ['Seats Filled', 0],
              ['Waitlist Filled', 2],
            ] as const
          ).map(([label, offset]) => (
            <span
              key={label}
              className={`seating-label ${
                textClass === 'dark-content' ? 'dark-label' : 'light-label'
              }`}
            >
              {label}{' '}
              <span className={`seat-waitlist-stats ${textClass}`}>
                {formatSeatCount(seating, offset)}
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
